<template>
  <div>
    <div class="d-flex">
      <div v-if="user.avatar" class="widget--avatar">
        <img :src="user.avatar" :alt="user.firstName" />
      </div>
      <div v-else class="widget--avatar">
        <span :style="{ backgroundColor: primary }">{{
          user.firstName[0]
        }}</span>
      </div>
      <div class="widget--details-wrapper" style="width: 100%;">
        <div class="row widget--table-row mx-0">
          <div class="col">
            <h4>{{ user.firstName + " " + user.lastName }}</h4>
            <p class="-muted">
              <img src="~@/assets/media/icons/user.svg" alt="member icon" />
              <span>{{
                user.Roles && user.Roles.length > 0 ? user.Roles[0].name : ""
              }}</span>
            </p>
            <div class="row">
              <div class="col">
                <p v-if="user.email">
                  <img
                    src="~@/assets/media/icons/email.svg"
                    alt="email icon"
                  />{{ user.email }}
                </p>
                <p v-if="user.mobile">
                  <img
                    src="~@/assets/media/icons/call.svg"
                    alt="phone icon"
                  />{{ user.mobile }}
                </p>
              </div>
            </div>
          </div>
          <div class="col px-0 text-right" v-on-clickaway="handleBodyClick">
            <action-button
              class="mt-0 d-inline-block w-auto"
              label=""
              :theme="{ primary, secondary, event, danger }"
              @customEvent="() => (isOpenMakeBooking = true)"
            >
              Make a booking
            </action-button>
          </div>
        </div>
      </div>
    </div>
    <!-- End of Profile -->
    <div
      class="row align-items-end justify-content-between widget--table-row mx-0"
    >
      <div class="col px-0"><h4>Invoice</h4></div>
    </div>
    <div class="row mx-0" v-if="orders">
      <div class="col" v-if="orders.length > 0">
        <table class="table">
          <thead>
            <tr>
              <th>Invoice ID</th>
              <th>Amount</th>
              <th>Payment Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <template>
              <tr v-for="order of orders" :key="order.id">
                <td>{{ order.code }}</td>
                <td
                  v-if="
                    order.code === 'Contract for Private Office' ||
                      order.code === 'Contract for Virtual Office'
                  "
                >
                  &mdash;
                </td>
                <td v-else>
                  <span v-if="order.totalAmount">
                    Php
                    {{
                      order.totalAmount.toLocaleString("en-US", {
                        minimumFractionDigits: 2
                      })
                    }}
                  </span>
                </td>
                <td class="font-weight-bold">
                  <span class="text-warning" v-if="order.cancelledAt">
                    Cancelled
                  </span>
                  <span class="text-success" v-else-if="order.paidAt">
                    &#10003; Paid
                  </span>
                  <span class="text-danger" v-else>
                    Unpaid
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      order.code === 'Contract for Private Office' ||
                        order.code === 'Contract for Virtual Office'
                    "
                    >&mdash;</span
                  >
                  <a
                    v-else
                    :style="{ color: primary }"
                    @click="handleViewInvoice(user.id, order.id)"
                    class="tag-link"
                    style="cursor: pointer"
                  >
                    View
                  </a>
                  <a
                    v-if="!order.paidAt && !order.cancelledAt"
                    @click="handleCancelInvoice(order.id, order.code)"
                    :style="{ color: danger, cursor: 'pointer' }"
                    class="ml-10 tag-link"
                    >Cancel</a
                  >
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="col mt-3 length-0" v-else>
        <span colspan="4">No orders found</span>
      </div>
    </div>
    <MakeBookingModal
      :userId="user.id"
      v-if="isOpenMakeBooking"
      @close="isOpenMakeBooking = false"
    />
  </div>
</template>

<script>
import { ActionButton } from "@/components";
import { dateToday } from "@/helpers/date";
import {
  bookingCancelEmail,
  bookingCancelEmailToOwner
} from "@/helpers/mailer";
import { mixin as clickaway } from "vue-clickaway";
import { mapActions, mapGetters } from "vuex";
import MakeBookingModal from "../../../../components/modals/MakeBookingModal.vue";

const data = () => ({ orders: [], isVisible: false, isOpenMakeBooking: false });
const components = {
  ActionButton,
  MakeBookingModal
};
const props = ["categories"];
const computed = {
  user() {
    return this.$store.state.admin.activeUser;
  },
  primary() {
    return this.$store.state.app.scheme.primary;
  },
  secondary() {
    return this.$store.state.app.scheme.secondary;
  },
  event() {
    return this.$store.state.app.scheme.event;
  },
  danger() {
    return this.$store.state.app.scheme.danger;
  }
};

const watch = {
  user() {
    this.paginatedInvoice();
  }
};

function created() {
  this.paginatedInvoice();
}

const methods = {
  async paginatedInvoice(page = 1) {
    if (page == 1) {
      this.orders = [];
    }

    this.$emit("loading", true);

    this.$http
      .get(`/orders?page[number]=${page}&page[size]=10&userId=${this.user.id}`)
      .then(async response => {
        const { data, meta } = response.data;
        this.orders = [...this.orders, ...data];
        this.$emit("ordersLength", this.orders.length);
        if (meta.hasNextPage) {
          await this.paginatedInvoice(page + 1);
          this.$emit("loading", true);
        } else {
          this.$emit("loading", false);
        }
      });
  },
  handleShowCategories() {
    if (this.GET_ORDERS().length) {
      if (this.GET_ORDER_USER() != this.user.id) {
        this.ORDER_SET_CURRENT_USER(this.user.id);
        this.ORDER_CLEAR();
        this.isVisible = !this.isVisible;
      } else {
        this.isVisible = !this.isVisible;
      }
    } else {
      this.ORDER_SET_CURRENT_USER(this.user.id);
      this.isVisible = !this.isVisible;
    }
  },
  handleCancelInvoice(id, code) {
    this.$swal({
      title: "Are you sure you want to cancel this order?",
      text: code,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#e15a4e",
      cancelButtonText: "No",
      reverseButtons: true
    }).then(async result => {
      if (result.value) {
        this.$http
          .patch("/orders/" + id, { cancelledAt: dateToday() })
          .then(() => {
            this.paginatedInvoice(1);
          });
        let specRecord = await this.$http.get(`/orders/${id}`).then(result => {
          return result.status == 200 ? result.data.data : [];
        });
        bookingCancelEmail({
          to: specRecord.User.email,
          displayName: specRecord.User.displayName,
          order: specRecord
        });

        bookingCancelEmailToOwner({
          fullName: specRecord.User.firstName + " " + specRecord.User.lastName,
          order: specRecord
        });
      }
    });
  },
  ...mapActions({
    ORDER_SET_CURRENT_USER: "ORDER_SET_CURRENT_USER",
    ORDER_CLEAR: "ORDER_CLEAR"
  }),
  ...mapGetters({
    GET_ORDER_USER: "GET_ORDER_USER",
    GET_ORDERS: "getOrders"
  }),
  handleViewInvoice(userId, orderId) {
    this.$router.push({
      path: `/admin/booking/${userId}/invoice/${orderId}`
    });
  },
  handleBodyClick() {
    this.isVisible = false;
  }
};

const mixins = [clickaway];

export default {
  created,
  components,
  computed,
  data,
  methods,
  props,
  watch,
  mixins
};
</script>

<style lang="scss" scoped>
@import "./__profile.scss";
</style>
